import React from "react";
import { SearchForm } from "./searchForm"
import OrganTree from "./organTree"
import OrganForm from "./organForm"
import { YhBox } from "@/components/YhBox";
import { OptType } from "../orgTypes";
import { globalPrompt } from "@/components/message";
import { Button } from "antd";
import { useOrgModel } from "../orgModel";
import OrganOldTree from "./organOldTree";
import { OrganOldForm } from "./organOldForm";

export function BaseOrganization() {
    const { searchParam, treeSource, organTreePRow, organTreeRow, organTreeRowKey, root, setOptType, setRoot, setAddTreeFrom, removeTreeForm, loadData, setOrganTreeRowKey, setOrganTreeRow, setOrganTreePRow, } = useOrgModel()
    const addPeer = () => {
        let rowCode = organTreeRow.code as string
        let rowCodeSlice = rowCode.slice(0, rowCode.length - 1)
        let pcodeLen = organTreePRow?.children?.length as number
        if (organTreePRow) {
            setAddTreeFrom({
                pcode: organTreeRow.pcode,
                code: rowCodeSlice + (pcodeLen + 1),
                branch: organTreeRow.branch
            })
            setRoot(true)
        } else {//当前选中为根级元素的时候，他的字典编码是可以自定义编辑的
            setRoot(false)
            setAddTreeFrom({})
        }
        setOptType(OptType.ADD_SAME_LEVEL);

    }
    const addSon = () => {
        const { children, code } = organTreeRow
        let dictRowLen = children?.length as number
        setAddTreeFrom({
            pcode: code,
            code: `${code}-0${dictRowLen >= 10 ? dictRowLen + 1 : '0' + (dictRowLen + 1)}`,
            branch: organTreeRow.branch
        })
        setRoot(true)
        setOptType(OptType.ADD_CHILD_LEVEL);
    }
    const remove = () => {
        if (organTreeRowKey.length == 0) {
            return globalPrompt("message", { type: "error", text: "请先选择要删除的值" })
        }
        removeTreeForm()
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={organTreeRowKey.length == 0}
            onClick={() => addPeer()}
        >增加同级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            disabled={organTreeRowKey.length == 0}
            onClick={() => addSon()}
        >增加下级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => remove()}
        >删除</Button>
    </>
    return (
        <>
            <SearchForm />
            <YhBox title="机构组织管理" action={action} style={{ height: 'calc(100vh - 125px)' }}>
                <div className="dict-container flex">
                    <div className="org-list-box">
                        <OrganTree />
                    </div>
                    <div className="org-from-box flex" style={{}}>
                        <OrganForm />
                        <div style={{border:'1px solid #c6c6c6'}}></div>                         <OrganOldForm />
                    </div>
                    <div className="org-list-box">
                        <OrganOldTree />
                    </div>
                </div>
            </YhBox>
        </>
    )
}
